// @ts-check
import React from 'react';

export const DashboardContext = React.createContext(
    /** @type {import('/b2b/common/hoc/withAsyncData').HocAsyncDataContext<UcReportsData>} */ ({
        loading: false,
        error: null,
        load: () => Promise.reject(new Error('Not implemented')),
        data: {
            configs: { total: 0, unpublished: 0 },
            integrations: { total: 0, errored: 0 },
            privacyProtocols: { total: 0, gpc: 0 },
            privacyProtocolNames: {},
        },
    })
);

export default DashboardContext;
